import React from 'react';
import { FundActivity } from './FundDetails';

interface ActivityDetailsModalProps {
  activity: FundActivity | null;
  isOpen: boolean;
  onClose: () => void;
}

const ActivityDetailsModal: React.FC<ActivityDetailsModalProps> = ({
  activity,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !activity) return null;

  const formatActivityType = (type: string) => {
    return type.replace(/_/g, ' ');
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center border-b pb-3">
          <h3 className="text-xl font-semibold text-gray-900">
            Activity Details: {formatActivityType(activity.type)}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mt-4">
          <div className="mb-4">
            <span className="px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">
              {formatActivityType(activity.type)}
            </span>
            <span className="ml-2 text-sm text-gray-500">
              {formatDate(activity.createdAt)}
            </span>
          </div>

          {activity.user && (
            <div className="mb-4 flex items-center">
              {activity.user.image ? (
                <img
                  src={activity.user.image}
                  alt={activity.user.name}
                  className="w-8 h-8 rounded-full mr-2"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-gray-300 mr-2 flex items-center justify-center">
                  {activity.user.name.charAt(0)}
                </div>
              )}
              <div>
                <div className="text-sm font-medium text-gray-900">
                  {activity.user.name}
                </div>
                <div className="text-sm text-gray-500">
                  {activity.user.email}
                </div>
              </div>
            </div>
          )}

          <div className="mt-4">
            <h4 className="text-md font-medium mb-2">Activity Data:</h4>
            <div className="bg-gray-50 p-4 rounded-md overflow-auto max-h-96">
              <pre className="text-sm text-gray-600 whitespace-pre-wrap">
                {JSON.stringify(activity.data, null, 2)}
              </pre>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivityDetailsModal;
